import { UserManagerProvider } from './../providers/user-manager/user-manager';
import { Subscription } from 'rxjs/Subscription';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/filter';
import 'rxjs/add/operator/take';
import 'rxjs/add/operator/takeUntil';
import 'rxjs/add/operator/timeout';
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/share';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/retryWhen';
import 'rxjs/add/operator/delayWhen';
import 'rxjs/Rx';
import { WebSocketSubject } from 'rxjs/observable/dom/WebSocketSubject';
import { Constants, CreditCard } from '../util/Constants';
import { Util } from '../util/Util';
import { MatchDetailsHeaderObject, FbBetRow, FbBet } from '../model/MatchDetailsHeaderObject';
import { UserProfile } from '../model/UserProfile';
import { Events, AlertController, App } from 'ionic-angular';
import { TranslateService } from '@ngx-translate/core';
import { CustomStorageProvider } from '../providers/custom-storage/custom-storage';
import { BehaviorSubject } from "rxjs/BehaviorSubject";
import { FbPersonalTips } from '../model/FbPersonalTips';
import { FbPersonalTipsComponent } from '../components/fb-personal-tips/fb-personal-tips';
import { TipsterInfoMatchRecordRowComponent } from '../components/tipster-info-match-record-row/tipster-info-match-record-row';
import { FbBetModel } from '../model/FbBetModel';
import { FbTipPrice } from '../model/FbTipPrice';
import { TipsterInfoMatchRecord } from '../model/TipsterInfoMatchRecord';
import { FbPersonalTipsPackage } from '../model/FbPersonalTipsPackage';
import { FbPersonalTipsPackageComponent } from '../components/fb-personal-tips-package/fb-personal-tips-package';
import { FbTipsterInfo } from '../model/FbTipsterInfo';
import { LoadingCtrlProvider } from '../providers/loading-ctrl/loading-ctrl';


@Injectable()
export class WebSocketService {
  private subject: WebSocketSubject<any>;
  private reqId: number;
  private keepAliveSubscription: Subscription;
  private showingPopUp = false;
  public connectionStatusSubject: BehaviorSubject<boolean>;
  private paused: boolean = false;
  private pingInterval: any;

  constructor(private alertCtrl: AlertController,
    private customStorageService: CustomStorageProvider,
    private translateService: TranslateService, private userManager: UserManagerProvider,
    private events: Events, private app: App, private loadingCtrl: LoadingCtrlProvider) {
    this.reqId = 0;
    this.connectionStatusSubject = new BehaviorSubject<boolean>(false);
  }

  public destroy(reason: string = "logout") {
    if (reason == "pause") {
      this.paused = true;
    }

    if (this.subject != null) {
      if (this.subject.socket != null && this.subject.socket.readyState == this.subject.socket.OPEN) {
        console.log("[destroy] Close with reason: " + reason);
        this.subject.socket.close(1000, reason);
      }

      if (this.keepAliveSubscription != null) {
        console.log("[destroy] Unsubscribe keep alive");
        this.keepAliveSubscription.unsubscribe();
      }
    }
  }

  public isConnected() {
    //return this.subject != null;
    if (this.subject && this.subject.socket) {
      return this.subject.socket.readyState == WebSocket.OPEN;
    }

    return false;

  }

  public isConnecting() {
    //return this.subject != null;
    if (this.subject && this.subject.socket) {
      return this.subject.socket.readyState == WebSocket.CONNECTING;
    }

    return false;

  }

  private showLogin() {
    /*
    if (!this.showingLogin) {
      setTimeout(() => {
        let loginModal = this.modalCtrl.create(LoginPage, {}, {
          enableBackdropDismiss: false
        });
        this.showingLogin = true;
        loginModal.present();
        loginModal.onDidDismiss(data => {
          this.showingLogin = false;
        });
      }, 100);
    } else {}
    */
    window.location.href = "index.html";
  }

  private confirmRetry(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      if (this.showingPopUp) {
        resolve(true);
        return;
      }

      this.translateService.get("confirmRetryWSTitle").subscribe((res: string) => {
        let confirm = this.alertCtrl.create({
          title: res,
          message: this.translateService.instant("confirmRetryWSContent"),
          enableBackdropDismiss: false,
          buttons: [
            {
              text: this.translateService.instant("cancel"),
              role: 'cancel',
              handler: () => {
                this.userManager.logout();
                this.showLogin();
                resolve(true);
                this.showingPopUp = false;
              }
            },
            {
              text: this.translateService.instant("ok"),
              handler: () => {
                //this.getFbMatchDays(Constants.LANG_ZH_TW);
                //this.create(url);
                resolve(true);
                this.showingPopUp = false;
              }
            }
          ]
        });
        this.showingPopUp = true;
        confirm.present();
      })
    });
  }

  private keepAlive() {
    if (this.keepAliveSubscription) {
      this.keepAliveSubscription.unsubscribe();
    }
    /*
        if (this.subject == null) {
          try {
            this.connectWS();
            return;
          } catch (ex) {
            console.log(ex);
            return;
          }
        }
     */

    // maintain websocket
    this.keepAliveSubscription = this.subject
      /*.retryWhen(errors => {
        return errors.switchMap(srcErr => {
          console.log("Keep alive retryWhen");
          console.log(srcErr);
          //return this.connectionStatusSubject.asObservable().share().filter(isConnected => isConnected == true).take(1);
          //return Observable.of(true).delayWhen(val => Observable.timer(1000));
          return Observable.fromPromise(this.confirmRetry());
          //return errors.delayWhen(err => Observable.timer(1000));
        })

      })*/
      .map(res => {
        let command = -1;
        let result = "";
        if (res['clientEvent'] != undefined && res.clientEvent.Error == undefined) {
          command = res.clientEvent.command;
          result = res.clientEvent[Constants.WS_CODES_KEY_MAP[res.clientEvent.command]];
        }

        return {
          'command': command,
          'result': res.clientEvent[Constants.WS_CODES_KEY_MAP[res.clientEvent.command]]
        };
      })
      .subscribe(
      response => {
        if (response.command == Constants.WS_CODE_ACCESS_DENIED) {
        } else if (response.command == Constants.WS_CODE_BROADCAST_FB_COMMENT || response.command == Constants.WS_CODE_BROADCAST_FB_TIPS_COMMENT || response.command == Constants.WS_CODE_BROADCAST_BLOCKED_FB_COMMENT
          || response.command == Constants.WS_CODE_BROADCAST_HOT_NEWS || response.command == Constants.WS_CODE_BROADCAST_DISCUSSION || response.command == Constants.WS_CODE_BROADCAST_BLOCK_RACE_COMMENT
          || response.command == Constants.WS_CODE_BROADCAST_TIPS_PACKAGE_COMMENT || response.command == Constants.WS_CODE_BROADCAST_TIPS_COMMENT || response.command == Constants.WS_CODE_BROADCAST_RACE_STARTED
          || response.command == Constants.WS_CODE_BROADCAST_RACE_ENDED || response.command == Constants.WS_CODE_BROADCAST_HORSE_TIPS_REMINDER || response.command == Constants.WS_CODE_BROADCAST_RADIO
          || response.command == Constants.WS_CODE_BROADCAST_RECEIVE_VOUCHER) {
          this.events.publish(response.command.toString(), response.result);
        }
      },
      err => {
        // dummy to catch error
        console.log("Keep alive subscription received error");
        console.log(err);
      },
      () => {
        console.log("Keep alive subscription completed");
      }
      );

  }


  public create(url: string): WebSocketSubject<any> {
    if (this.isConnected()) {
      this.destroy();
    }

    console.log("1.Connecting to Websocket: " + url);
    this.subject = WebSocketSubject.create({
      url: url,
      openObserver: {
        next: (e: Event) => {
          this.paused = false;
          this.connectionStatusSubject.next(true);
          console.log("Open Observer Event");
          console.log(e);
          this.pingInterval = setInterval(() => {
            this.sendPing();
          }, 10000);
          this.keepAlive();
        }
      },
      closeObserver: {
        next: (e: CloseEvent) => {
          clearInterval(this.pingInterval);
          //this.subject = null;
          this.connectionStatusSubject.next(false);
          console.log("Close Observer Event");
          console.log(e);
          let code = e.code;
          let reason = e.reason;
          console.log("code: " + code + ", reason: " + reason + ", paused: " + this.paused);

          // do nothing if the app is paused
          if (this.paused) {
            return;
          }

          if (code == 1000 && reason == "") {
            if (this.subject == null || this.subject.socket == null || this.subject.socket.readyState == this.subject.socket.CLOSED || this.subject.socket.readyState == this.subject.socket.CLOSING) {
              this.connectWS();
            }
          } else if (reason != "Unexpected reconnect" && reason != "logout") {
            if (this.subject == null || this.subject.socket == null || this.subject.socket.readyState == this.subject.socket.CLOSED || this.subject.socket.readyState == this.subject.socket.CLOSING) {
              console.log("Can resubscribe now");
              this.confirmRetry().then(response => {
                this.connectWS();
              }, err => {
                console.log("Close observable error:");
                console.log(err);
              })
            }
          }
        }
      }
    });
    //this.keepAlive();
    this.subject.publish().connect();
    return this.subject;
  }


  public createWs(userId: any, webSecret: string): WebSocketSubject<any> {
    let webSocketUrl = this.customStorageService.get<string>(Constants.STORAGE_KEY_WEB_SOCKET_URL);
    if (webSocketUrl == null) {
      throw new Error(Constants.CLIENT_ERROR_CODE_WEB_SOCKET_URL_INVALID);
    }
    return this.create(webSocketUrl + "/1.0/" + userId + "/" + webSecret);
  }

  public listenToBroadcast(registeredBroadcast?: Array<number>): Observable<any> {
    if (!this.subject) {
      throw new Error(Constants.CLIENT_ERROR_CODE_WEB_SOCKET_NOT_READY);
    }
    return this.subject.share()
      .retryWhen(errors => {
        console.log("[listenToBroadcast] retryWhen error");
        /*
        return errors.switchMap(srcErr => {
            console.log("Retrying listen broadcast");
            return Observable.of(true);
          });
          */

        return errors.delayWhen(err => {
          console.log("Retrying listen broadcast");
          console.log(err);
          return Observable.timer(1000);
        }

        );

      })
      .filter(
      res => {
        console.log("Filtering broadcast");
        if (registeredBroadcast == null) {
          return false;
        }
        return registeredBroadcast.indexOf(res.clientEvent.command) > -1;
        //|| res.clientEvent.command == Constants.WS_ACCESS_DENIED_CODE;
        /*return res.clientEvent.command == Constants.WS_ACK_CODE
        || res.clientEvent.command == Constants.WS_ACCESS_DENIED_CODE ;*/
      }
      )
      .map(
      res => {

        if (res['clientEvent'] == undefined) {
          console.log("[listenToBroadcast] Received Invalid response");
          throw new Error(Constants.CLIENT_ERROR_CODE_INVALID_RESPONSE);
        }

        if (res.clientEvent.Error != undefined) {
          console.log("[listenToBroadcast] Received error");
          throw new Error(JSON.stringify(res));
        }

        /*
      if (res.clientEvent.command == Constants.WS_ACCESS_DENIED_CODE) {
        throw new Error(Constants.CLIENT_ERROR_CODE_ACCESS_DENIED);
      }
      */

        return {
          'command': res.clientEvent.command,
          'result': res.clientEvent[Constants.WS_CODES_KEY_MAP[res.clientEvent.command]]
        };
      }
      );

  }

  public connectWS(): WebSocketSubject<any> {
    this.destroy();
    let savedUserId = this.customStorageService.get<string>(Constants.STORAGE_KEY_USER_ID);
    let savedWebSecret = this.customStorageService.get<string>(Constants.STORAGE_KEY_WEB_SECRET);
    return this.createWs(savedUserId, savedWebSecret);
  }

  public resetPaused(): void {
    this.paused = false;
  }

  public getFbMatchDays(langName: string) {
    let reqCmd = Constants.WS_CODE_GET_MATCH_REQUEST;
    let respCmd = Constants.WS_CODE_GET_MATCH_RESPONSE;
    let param = {
      langName: langName
    };
    return this.send(param, reqCmd, respCmd);
  }

  public getFbTipsters(startIdx: number, endIdx: number, subscribeType: number, subscriberType: number, nickname: string, order: number, isShowLoading: boolean) {
    let reqCmd = Constants.WS_CODE_GET_FB_TIPSTERS_REQUEST;
    let respCmd = Constants.WS_CODE_GET_FB_TIPSTERS_RESPONSE;
    let param = {
      startIdx: startIdx,
      endIdx: endIdx,
      subscribeType: subscribeType,
      subscriberType: subscriberType,
      nickname: nickname,
      order: order
    };
    return this.send(param, reqCmd, respCmd, true, isShowLoading);
  }

  public addFbComment(iTopicId: number, sMsg: string, sImg: string, iRefCmtId: number) {
    let reqCmd = Constants.WS_CODE_ADD_FB_COMMENT_REQUEST;
    let respCmd = Constants.WS_CODE_ADD_FB_COMMENT_RESPONSE;
    let param = {
      topicId: iTopicId,
      message: sMsg,
      image: sImg,
      refCommentId: iRefCmtId
    };
    return this.send(param, reqCmd, respCmd);
  }

  public addShareFbComment(iTopicId: number, sMsg: string, shareImage: string, shareImageType: number, langName: string) {
    let reqCmd = Constants.WS_CODE_ADD_FB_COMMENT_REQUEST;
    let respCmd = Constants.WS_CODE_ADD_FB_COMMENT_RESPONSE;
    let param = {
      topicId: iTopicId,
      message: sMsg,
      shareImage: shareImage,
      shareImageType: shareImageType,
      shareLang: langName
    };
    return this.send(param, reqCmd, respCmd);
  }

  public addFbTipsComment(iTopicId: number, sMsg: string, sImg: string, iRefCmtId: number, sTipsId: number) {
    let reqCmd = Constants.WS_CODE_ADD_FB_TIPS_COMMENT_REQUEST;
    let respCmd = Constants.WS_CODE_ADD_FB_TIPS_COMMENT_RESPONSE;
    let param = {
      topicId: iTopicId,
      message: sMsg,
      image: sImg,
      refCommentId: iRefCmtId,
      tipsId: sTipsId,
      tipsPackage: true
    };
    return this.send(param, reqCmd, respCmd);
  }

  public addFbTipsPackageComment(iTipsId: number, sMsg: string, sImg: string) {
    var img = "";
    if (sImg != null && sImg != "") {
      // extract the data part
      img = sImg.split(",")[1];
    }
    let reqCmd = Constants.WS_CODE_ADD_FB_TIPS_PACKAGE_NOTES_REQUEST;
    let respCmd = Constants.WS_CODE_ADD_FB_TIPS_PACKAGE_NOTES_RESPONSE;
    let param = {
      id: iTipsId,
      note: sMsg,
      image: img,
    };
    return this.send(param, reqCmd, respCmd);
  }

  public getFbComment(iTopicId: number, iStartIdx: number, iEndIdx: number) {
    let reqCmd = Constants.WS_CODE_GET_FB_COMMENT_REQUEST;
    let respCmd = Constants.WS_CODE_GET_FB_COMMENT_RESPONSE;
    let param = {
      topicId: iTopicId,
      startIdx: iStartIdx,
      endIdx: iEndIdx
    };
    return this.send(param, reqCmd, respCmd);
  }

  public getFbTipsComment(iTopicId: number, iStartIdx: number, iEndIdx: number, sTipsId: string) {
    let reqCmd = Constants.WS_CODE_GET_FB_TIPS_COMMENT_REQUEST;
    let respCmd = Constants.WS_CODE_GET_FB_TIPS_COMMENT_RESPONSE;
    let param = {
      topicId: iTopicId,
      startIdx: iStartIdx,
      endIdx: iEndIdx,
      tipsId: sTipsId,
      tipsPackage: true
    };
    return this.send(param, reqCmd, respCmd);
  }

  public blockComment(iTopicId: number, iId: number, isCensored: boolean, isTempCensored: boolean) {
    let reqCmd = Constants.WS_CODE_BLOCK_FB_COMMENT_REQUEST;
    let respCmd = Constants.WS_CODE_BLOCK_FB_COMMENT_RESPONSE;
    let param = {
      topicId: iTopicId,
      id: iId,
      censored: isCensored,
      tempCensored: isTempCensored
    };
    return this.send(param, reqCmd, respCmd);
  }

  public getFbMatchBets(iMatchId: number) {
    let reqCmd = Constants.WS_CODE_GET_FB_MATCH_DETAIL_REQUEST;
    let respCmd = Constants.WS_CODE_GET_FB_MATCH_DETAIL_RESPONSE;
    let param = {
      id: iMatchId
    };
    return this.send(param, reqCmd, respCmd);
  }

  public addFbTips(iMatchId: number, iPrice: number, iBtAmount: number, fbBet: Array<FbBet>,
    sNote: string, sImg: string, sTipsPackageNotes: string, sTipsPackageImg: string) {
    var img = "";
    if (sImg != null) {
      // extract the data part
      img = sImg.split(",")[1];
    }
    var tipsPackageImg = "";
    if (sImg != null) {
      // extract the data part
      tipsPackageImg = sTipsPackageImg.split(",")[1];
    }
    let reqCmd = Constants.WS_CODE_ADD_FB_TIPS_REQUEST;
    let respCmd = Constants.WS_CODE_ADD_FB_TIPS_RESPONSE;
    let param = {
      matchId: iMatchId,
      price: iPrice,
      betAmount: iBtAmount,
      fbBet: fbBet,
      note: sNote,
      image: img,
      packageNote: sTipsPackageNotes,
      packageImage: tipsPackageImg
    };
    return this.send(param, reqCmd, respCmd);
  }

  public getFbBetAmount(iMatchId: number) {
    let reqCmd = Constants.WS_CODE_GET_BET_AMOUNT_QUOTA_REQUEST;
    let respCmd = Constants.WS_CODE_GET_BET_AMOUNT_QUOTA_RESPONSE;
    let param = {
      id: iMatchId
    };
    return this.send(param, reqCmd, respCmd);
  }

  public getFbPersonalTips(iMatchId: number, matchDay: string) {
    let reqCmd = Constants.WS_CODE_GET_FB_PERSONAL_TIPS_REQUEST;
    let respCmd = Constants.WS_CODE_GET_FB_PERSONAL_TIPS_RESPONSE;
    let param = {
      id: iMatchId,
      matchDay: matchDay
    };
    return this.send(param, reqCmd, respCmd);
  }

  public getFbPersonalTipsPackage(sJCMatchDate: string) {
    let reqCmd = Constants.WS_CODE_GET_FB_PERSONAL_TIPS_REQUEST;
    let respCmd = Constants.WS_CODE_GET_FB_PERSONAL_TIPS_RESPONSE;
    let param = {
      id: 0,
      date: sJCMatchDate
    };
    return this.send(param, reqCmd, respCmd);
  }

  public getFbTipsPackageDetails(tipsPackageId: number, langName: string) {
    let reqCmd = Constants.WS_CODE_GET_TIPS_PACKAGE_DETAILS_REQUEST;
    let respCmd = Constants.WS_CODE_GET_TIPS_PACKAGE_DETAILS_RESPONSE;
    let param = {
      id: tipsPackageId,
      lang: langName
    };
    return this.send(param, reqCmd, respCmd);
  }

  public getFbTipsPackageWithMatchDate(matchDate: string) {
    let reqCmd = Constants.WS_CODE_GET_TIPS_PACKAGE_DETAILS_REQUEST;
    let respCmd = Constants.WS_CODE_GET_TIPS_PACKAGE_DETAILS_RESPONSE;
    let param = {
      matchDate: matchDate
    };
    return this.send(param, reqCmd, respCmd);
  }

  public buyFbTip(iTipId: number) {
    let reqCmd = Constants.WS_CODE_BUY_FB_TIPS_REQUEST;
    let respCmd = Constants.WS_CODE_BUY_FB_TIPS_RESPONSE;
    let param = {
      id: iTipId,
      tipsPackage: false
    };
    return this.send(param, reqCmd, respCmd);
  }

  public buyFbTipsPackageReq(tipsPackageId: number) {
    let reqCmd = Constants.WS_CODE_BUY_TIPS_PACKAGE_REQUEST;
    let respCmd = Constants.WS_CODE_BUY_TIPS_PACKAGE_RESPONSE;
    let param = {
      id: tipsPackageId,
    };
    return this.send(param, reqCmd, respCmd, false);
  }

  public queryUnionPay(langName) {
    let reqCmd = Constants.WS_CODE_QUERY_UNION_PAY_REQUEST;
    let respCmd = Constants.WS_CODE_QUERY_UNION_PAY_RESPONSE;
    var param = {
      "langName": langName
    };
    return this.send(param, reqCmd, respCmd, false);
  }

  public queryVisaMaster(langName) {
    let reqCmd = Constants.WS_CODE_QUERY_VISA_MASTER_REQUEST;
    let respCmd = Constants.WS_CODE_QUERY_VISA_MASTER_RESPONSE;
    var param = {
      "langName": langName
    };
    return this.send(param, reqCmd, respCmd, false);
  }

  public buyFbTipsPackageNUpdateData(fbPersonalTipsComponent: FbPersonalTipsComponent, availableFbPersonalTips: Array<FbPersonalTipsPackage>, purchasedFbPersonalTips: Array<FbPersonalTipsPackage>): Promise<any> {
    return new Promise((resolve, reject) => {
      let confirm = this.alertCtrl.create({
        title: this.translateService.instant("confirmBuyTipsTitle"),
        message: this.translateService.instant("confirmBuyTipsContent"),
        buttons: [
          {
            text: this.translateService.instant("cancel"),
            role: 'cancel',
            handler: () => {
              console.log('Cancel clicked');
            }
          },
          {
            text: this.translateService.instant("ok"),
            handler: () => {
              let iFbTipId = fbPersonalTipsComponent.fbPersonalTip.tipId;
              this.buyFbTipsPackageReq(iFbTipId).then(fbTip => {

                fbPersonalTipsComponent.fbPersonalTip.fbBetList[0].betAmount = Util.getActualNumber(fbTip.betAmount);
                fbPersonalTipsComponent.fbPersonalTip.fbBetList[0].odds = Util.getActualNumber(fbTip.fbBet.odds).toString();
                //fbPersonalTipsComponent.fbPersonalTip.betItemOption = Constants.Enum_BetItemOption[fbTip.fbBet.itemOption];
                fbPersonalTipsComponent.fbPersonalTip.fbBetList[0].betItemOption = fbTip.fbBet.itemOption;
                fbPersonalTipsComponent.fbPersonalTip.fbTipPrice.purchased = fbTip.purchased;;
                fbPersonalTipsComponent.fbPersonalTip.fbBetList[0].winningMargin = fbTip.fbBet.winningMargin;
                let langName = this.customStorageService.get<string>(Constants.STORAGE_KEY_LANG);
                this.getFbTransactions(langName).then(transactions => {
                  availableFbPersonalTips.forEach(element => {
                    element.fbTipPrice.voucherBalance = transactions.voucherBalance;
                  });
                },
                  err => {
                    console.log("[TransactionPage] Error: " + err.message);
                    reject(err);
                  });
                resolve(fbTip);
              },
              errorResp => { // custom error handling for buying tips
                let responseCode = errorResp.code;
                if (responseCode == null) {
                  responseCode = "ce100003";
                }

                let sTitle;
                let sSubTitle;

                if (responseCode == "100015") {
                  sTitle = this.translateService.instant(responseCode);
                  sSubTitle = this.translateService.instant("buyTipsNotEnoughCoin");
                } else {
                  sTitle = this.translateService.instant("error");
                  sSubTitle = this.translateService.instant(responseCode);
                }

                let alert = this.alertCtrl.create({
                  title: sTitle,
                  subTitle: sSubTitle,
                  buttons: [
                    {
                      text: this.translateService.instant("cancel"),
                      role: "cancel"
                    },
                    {
                      text: this.translateService.instant("ok"),
                      handler: ()=> {
                        if (responseCode == "100015") {
                          if (this.app.getActiveNavs() != null && this.app.getActiveNavs().length > 0) {
                            let navCtrl = this.app.getActiveNavs()[0];
                            navCtrl.push("ShopMenuPage").then(result => {
                              if (!result) {
                                navCtrl.push("InAppPurchasePage");
                              }
                            })
                          }
                        }
                      }
                    }
                  ]
                });

                alert.present();
                alert.onDidDismiss(() => {
                  reject(errorResp);
                });

              });

            }
          }
        ]
      });
      confirm.present();
    });
  }

  public buyFbTipsPackageWithDetailMsg(packageId: number, aMatchNum: number[], lastMatchNum: number, lastMatchStatus: number, lastMatchDate: string,
    lastMatchStartTime: string, isVoucherAvailable: boolean, iTipPrice: number,
    fbPersonalTipsPackageComponent?: FbPersonalTipsPackageComponent, availableFbPersonalTips?: Array<FbPersonalTipsPackage>, purchasedFbPersonalTips?: Array<FbPersonalTipsPackage>): Promise<any> {
    return new Promise((resolve, reject) => {
      if (isVoucherAvailable) {
        this.buyFbTipsPackageRequest(packageId, fbPersonalTipsPackageComponent, availableFbPersonalTips).then((fbTip) => {
          resolve(fbTip);
        }).catch(err => reject(err));
      } else {
        let confirm = this.alertCtrl.create({
          title: this.translateService.instant("confirmBuyTipsTitle"),
          message: this.getBuyTipsPackageMessage(aMatchNum, lastMatchNum, lastMatchStatus, lastMatchDate, lastMatchStartTime, iTipPrice),
          buttons: [
            {
              text: this.translateService.instant("cancel"),
              role: 'cancel',
              handler: () => {
                console.log('Cancel clicked');
              }
            },
            {
              text: this.translateService.instant("ok"),
              handler: () => {
                // let iFbTipId = fbPersonalTipsPackageComponent.fbPersonalTipsPackage.tipId;
                this.buyFbTipsPackageRequest(packageId, fbPersonalTipsPackageComponent, availableFbPersonalTips).then((fbTip) => {
                  resolve(fbTip);
                }).catch(err => reject(err));
              }
            }
          ]
        });
        confirm.present();
      }
    });
  }

  private buyFbTipsPackageRequest(packageId: number, fbPersonalTipsPackageComponent?: FbPersonalTipsPackageComponent,
    availableFbPersonalTips?: Array<FbPersonalTipsPackage>) : Promise<any> {
      return new Promise<any>((resolve, reject) => {
        this.buyFbTipsPackageReq(packageId).then(fbTip => {
          if (fbPersonalTipsPackageComponent != null) {
            fbPersonalTipsPackageComponent.fbPersonalTipsPackage.fbTipPrice.purchased = fbTip.purchased;;
            let langName = this.customStorageService.get<string>(Constants.STORAGE_KEY_LANG);
            this.getFbTransactions(langName).then(transactions => {
              availableFbPersonalTips.forEach(element => {
                element.fbTipPrice.voucherBalance = transactions.voucherBalance;
              });
            },
              err => {
                console.log("[TransactionPage] Error: " + err.message);
                reject(err);
              });
          }
          resolve(fbTip);
        },
        errorResp => { // custom error handling for buying tips
          reject(errorResp);
        });
      });
  }

  public getBuyTipsPackageMessage(aMatchNum: number[], lastMatchNum: number, lastMatchStatus: number, lastMatchDate: string, lastMatchStartTime: string, iTipPrice: number): string {
    let errMsg = this.translateService.instant("confirmBuyTipsContentWithPrice", { 'price': "$" + iTipPrice }) + "<br/><br/>";
    errMsg += this.translateService.instant("tipsPackageMatchNum") + ":&nbsp;";
    let sMatchNum = "";
    for (let matchNum of aMatchNum) {
      if (sMatchNum != "") {
        sMatchNum += ", ";
      }
      sMatchNum += matchNum;
    }
    errMsg += sMatchNum + "<br/><br/>";
    errMsg += this.translateService.instant("lastMatch") + ": &nbsp;" + lastMatchNum + "&nbsp;";
    if (lastMatchStatus == 0) {
      errMsg += "(" + Util.getMatchStatus(lastMatchStatus, this.translateService) + ")<br/>";
    } else {
      errMsg += "<span class='startedMatch'>(" + Util.getMatchStatus(lastMatchStatus, this.translateService) + ")</span><br/>";
    }
    errMsg += this.translateService.instant("lastMatchStartTime") + ": &nbsp;";
    errMsg += Util.getMatchDate(lastMatchDate) + "&nbsp;";
    errMsg += Util.getMatchTime(lastMatchStartTime);
    return errMsg;
  }

  public buyFbTipsPackage(packageId: number, fbTipPrice: FbTipPrice, fbPersonalTipsPackageComponent?: FbPersonalTipsPackageComponent, availableFbPersonalTips?: Array<FbPersonalTipsPackage>, purchasedFbPersonalTips?: Array<FbPersonalTipsPackage>): Promise<any> {
    return new Promise((resolve, reject) => {
      if (Util.isVoucherAvailable(fbTipPrice)) {
        this.buyFbTipsPackageRequest(packageId, fbPersonalTipsPackageComponent, availableFbPersonalTips).then((fbTip) => {
          resolve(fbTip);
        }).catch(err => reject(err));
      } else {
        let confirm = this.alertCtrl.create({
          title: this.translateService.instant("confirmBuyTipsTitle"),
          message: this.translateService.instant("confirmBuyTipsContentWithPrice", { 'price': "$" + fbTipPrice.tipPrice }),
          buttons: [
            {
              text: this.translateService.instant("cancel"),
              role: 'cancel',
              handler: () => {
                console.log('Cancel clicked');
              }
            },
            {
              text: this.translateService.instant("ok"),
              handler: () => {
                // let iFbTipId = fbPersonalTipsPackageComponent.fbPersonalTipsPackage.tipId;
                this.buyFbTipsPackageRequest(packageId, fbPersonalTipsPackageComponent, availableFbPersonalTips).then((fbTip) => {
                  resolve(fbTip);
                }).catch(err => reject(err));
              }
            }
          ]
        });
        confirm.present();
      }
    });
  }

  public getFbTipDetails(iTipId: number) {
    let reqCmd = Constants.WS_CODE_GET_FB_TIPS_DETAILS_REQUEST;
    let respCmd = Constants.WS_CODE_GET_FB_TIPS_DETAILS_RESPONSE;
    let param = {
      id: iTipId
    };
    return this.send(param, reqCmd, respCmd);
  }

  public getTipsterInfo(iTipsterId: number) {
    let reqCmd = Constants.WS_CODE_GET_FB_TIPSTER_INFO_REQUEST;
    let respCmd = Constants.WS_CODE_GET_FB_TIPSTER_INFO_RESPONSE;
    let param = {
      id: iTipsterId
    };
    return this.send(param, reqCmd, respCmd);
  }

  public getTipsterLatestResult(iTipsterId: number) {
    let reqCmd = Constants.WS_CODE_GET_FB_TIPSTER_LATEST_RESULT_REQUEST;
    let respCmd = Constants.WS_CODE_GET_FB_TIPSTER_LATEST_RESULT_RESPONSE;
    let param = {
      id: iTipsterId
    };
    return this.send(param, reqCmd, respCmd);
  }

  public addFavorite(iMatch: number, favorite: boolean) {
    let reqCmd = Constants.WS_CODE_ADD_FAVOURITE_REQUEST;
    let respCmd = Constants.WS_CODE_ADD_FAVOURITE_RESPONSE;
    let param = {
      id: iMatch,
      favorite: favorite
    };
    return this.send(param, reqCmd, respCmd);
  }

  public subscribeFbTipster(iTipsterId: number, iSubscribeType: number) {
    let reqCmd = Constants.WS_CODE_SUBSCRIBE_FB_TIPSTER_REQUEST;
    let respCmd = Constants.WS_CODE_SUBSCRIBE_FB_TIPSTER_RESPONSE;
    let param = {
      tipster: iTipsterId,
      subscribeType: iSubscribeType
    };
    return this.send(param, reqCmd, respCmd);
  }

  public getFbTransactions(langName: string) {
    let reqCmd = Constants.WS_CODE_GET_FB_TRANSACTIONS_REQUEST;
    let respCmd = Constants.WS_CODE_GET_FB_TRANSACTIONS_RESPONSE;
    let param = {
      "langName": langName
    };
    return this.send(param, reqCmd, respCmd);
  }

  public getFbActivities(langName: string) {
    let reqCmd = Constants.WS_CODE_GET_FB_ACTIVITIES_REQUEST;
    let respCmd = Constants.WS_CODE_GET_FB_ACTIVITIES_RESPONSE;
    let param = {
      "langName": langName
    };
    return this.send(param, reqCmd, respCmd);
  }

  public updateTipsPackagePrice(tipsPackagePrice: number, allowVoucher: boolean, allowRefund: boolean) {
    let reqCmd = Constants.WS_CODE_UPDATE_TIPS_PACKAGE_PRICE_REQUEST;
    let respCmd = Constants.WS_CODE_UPDATE_TIPS_PACKAGE_PRICE_RESPONSE;
    var param = {
      "tipsPackagePrice": tipsPackagePrice,
      "allowVoucherBuyPackage": allowVoucher,
      "allowTipsPackageRefund": allowRefund
    };
    return this.send(param, reqCmd, respCmd);
  }


  public getHorseHotNews(userId, raceNum) {
    let reqCmd = Constants.WS_CODE_GET_HOT_NEWS_REQUEST;
    let respCmd = Constants.WS_CODE_GET_HOT_NEWS_RESPONSE;
    var param = {
      "userId": userId,
      "raceNum": raceNum
    };
    return this.send(param, reqCmd, respCmd);
  }

  public getHorsePersonalTips(userId, raceNum) {
    let reqCmd = Constants.WS_CODE_GET_PERSONAL_TIPS_REQUEST;
    let respCmd = Constants.WS_CODE_GET_PERSONAL_TIPS_RESPONSE;
    var param = {
      "userId": userId,
      "raceNum": raceNum
    };
    return this.send(param, reqCmd, respCmd);
  }

  public getRacingComment(raceId, startIdx, endIdx) {
    let reqCmd = Constants.WS_CODE_GET_RACE_COMMENT_REQUEST;
    let respCmd = Constants.WS_CODE_GET_RACE_COMMENT_RESPONSE;
    var param = {
      "raceId": raceId,
      "startIdx": startIdx,
      "endIdx": endIdx
    };
    return this.send(param, reqCmd, respCmd);
  }

  public getRacingCommentByCommentId(raceId, startCommentId, endCommentId) {
    let reqCmd = Constants.WS_CODE_GET_RACE_COMMENT_REQUEST;
    let respCmd = Constants.WS_CODE_GET_RACE_COMMENT_RESPONSE;
    var param = {
      "raceId": raceId,
      "startCommentId": startCommentId,
      "endCommentId": endCommentId
    };
    return this.send(param, reqCmd, respCmd);
  }

  public addRacingComment(raceId, message, image, refCommentId) {
    let reqCmd = Constants.WS_CODE_ADD_RACE_COMMENT_REQUEST;
    let respCmd = Constants.WS_CODE_ADD_RACE_COMMENT_RESPONSE;
    var param = {
      "topicId": raceId,
      "message": message,
      "image": image,
      "refCommentId": refCommentId
    };
    return this.send(param, reqCmd, respCmd);
  }

  public addShareRacingComment(raceId: number, message, shareImage, shareImageType, shareLang) {
    let reqCmd = Constants.WS_CODE_ADD_RACE_COMMENT_REQUEST;
    let respCmd = Constants.WS_CODE_ADD_RACE_COMMENT_RESPONSE;
    var param = {
      "topicId": raceId,
      "message": message,
      "shareImage": shareImage,
      "shareImageType": shareImageType,
      "shareLang": shareLang

    };
    return this.send(param, reqCmd, respCmd);
  }

  //	Add Racing Note
  //	{"clientEvent":{"RacingNote":{"Horse": {"id" : 123}, "RaceCard": {"raceId" : 999}, "notes" : "abc", "racingNoteOptions": [1,3,4]},"command":69,"seq":1}}
  public addRacingNote(horseId, raceId, notes, racingNoteOptions) {
    let reqCmd = Constants.WS_CODE_ADD_RACING_NOTE_REQUEST;
    let respCmd = Constants.WS_CODE_ADD_RACING_NOTE_RESPONSE;
    var param = {
      "Horse": { "id": horseId },
      "RaceCard": { "raceId": raceId },
      "notes": notes,
      "racingNoteOptions": racingNoteOptions
    };
    return this.send(param, reqCmd, respCmd);
  }

  //	Update Racing Note
  //	{"clientEvent":{"RacingNote":{"id" : 1, "notes" : "abc", "racingNoteOptions": [1,3,4]},"command":71,"seq":1}}
  public updateRacingNote(id, notes, racingNoteOptions) {
    let reqCmd = Constants.WS_CODE_UPDATE_RACING_NOTE_REQUEST;
    let respCmd = Constants.WS_CODE_UPDATE_RACING_NOTE_RESPONSE;
    var param = {
      "id": id,
      "notes": notes,
      "racingNoteOptions": racingNoteOptions
    };
    return this.send(param, reqCmd, respCmd);
  }

  //	Delete Racing Note
  //	{"clientEvent":{"RacingNote":{"id" : 1},"command":73,"seq":1}}
  public deleteRacingNote(id) {
    let reqCmd = Constants.WS_CODE_DELETE_RACING_NOTE_REQUEST;
    let respCmd = Constants.WS_CODE_DELETE_RACING_NOTE_RESPONSE;
    var param = {
      "id": id
    };
    return this.send(param, reqCmd, respCmd);
  }

  //	List All Horse Racing Note
  //	{"clientEvent":{"LanguageParam" : {"langName" : "ZH_TW"}, "command":75,"seq":1}}
  public listAllHorseRacingNote(langName) {
    let reqCmd = Constants.WS_CODE_GET_ALL_HORSE_RACING_NOTES_REQUEST;
    let respCmd = Constants.WS_CODE_GET_ALL_HORSE_RACING_NOTES_RESPONSE;
    var param = {
      "langName": langName
    };
    return this.send(param, reqCmd, respCmd);
  }

  //	Get Horse Racing Note
  //	{"clientEvent":{"HorseRacingNote" : {"lang" : "ZH_TW", "Horse" : {"id" : 1}}, "command":77,"seq":1}}
  public getHorseRacingNote(lang, horseId) {
    let reqCmd = Constants.WS_CODE_GET_HORSE_RACING_NOTE_REQUEST;
    let respCmd = Constants.WS_CODE_GET_HORSE_RACING_NOTE_RESPONSE;
    var param = {
      "langName": lang,
      "Horse": {
        "id": horseId
      }
    };
    return this.send(param, reqCmd, respCmd);
  }

  //	{"clientEvent":{"comment":{"result":false,"id":123,"raceId":0,"tipsId":1234,"message":"message","image":"image","username":"name","userId":456,"creationTime":"time"},"command":24,"seq":1}}
  public getHorseTipsComment(id, startIdx, endIdx, isTipsPackage, raceId) {
    let reqCmd = Constants.WS_CODE_GET_GET_TIPS_COMMENT_REQUEST;
    let respCmd = Constants.WS_CODE_GET_GET_TIPS_COMMENT_RESPONSE;
    var param = {
      "id": id,
      "startIdx": startIdx,
      "endIdx": endIdx,
      "tipsPackage": isTipsPackage,
      "raceId": raceId
    };
    return this.send(param, reqCmd, respCmd);
  }

  //	{"clientEvent":{"raceTip":{"result":false,"id":1324,"ownerId":0,"raceNo":0,"wpHorseNo":0,"qqpBanker":0},"command":26,"seq":1}}
  public addHorseTipsComment(tipsId, message, image, isTipsPackage, raceId, refCommentId) {
    let reqCmd = Constants.WS_CODE_GET_ADD_TIPS_COMMENT_REQUEST;
    let respCmd = Constants.WS_CODE_GET_ADD_TIPS_COMMENT_RESPONSE;
    console.log("tipsId: " + tipsId);
    var param = {
      "tipsId": tipsId,
      "message": message,
      "image": image,
      "tipsPackage": isTipsPackage,
      "topicId": raceId,
      "refCommentId": refCommentId
    };
    return this.send(param, reqCmd, respCmd);
  }

  public addShareHorseTipsPackageComment(message, shareImage, shareImageType, shareLang) {
    let reqCmd = Constants.WS_CODE_GET_ADD_TIPS_COMMENT_REQUEST;
    let respCmd = Constants.WS_CODE_GET_ADD_TIPS_COMMENT_RESPONSE;
    var param = {
      "message": message,
      "shareImage": shareImage,
      "tipsPackage": true,
      "topicId": -1,
      "shareImageType": shareImageType,
      "shareLang": shareLang
    };
    return this.send(param, reqCmd, respCmd);
  }

  //	{"clientEvent":{"RaceTip":{"result":false,"id":255,"lang":"en"},"command":22,"seq":1}}
  public getHorseRaceTips(id, lang, isTipsPackage) {
    let reqCmd = Constants.WS_CODE_GET_RACE_TIPS_REQUEST;
    let respCmd = Constants.WS_CODE_GET_RACE_TIPS_RESPONSE;
    var param = {
      "id": id,
      "lang": lang,
      "tipsPackage": isTipsPackage
    };
    return this.send(param, reqCmd, respCmd);
  }

  //	{"clientEvent":{"TipsterInfo":{"id": 112039},"command":48,"seq":1}}
  public getHorseLastResult(id) {
    let reqCmd = Constants.WS_CODE_GET_TIPSTER_LATEST_RESULT_REQUEST;
    let respCmd = Constants.WS_CODE_GET_TIPSTER_LATEST_RESULT_RESPONSE;
    var param = {
      "id": id
    };
    return this.send(param, reqCmd, respCmd);
  }


  //	 Sample to get Race Cards and Tips
  //	 {"clientEvent":{"LanguageParam":{"langName":"ZH_TW"},"command":6,"seq":1}}
  public getHorseRaceCards(langName, skipDetail) {
		/*
		var lsRaceCard = localStorageService.get(STORAGE_KEY_RACE_CARDS);

		var skipDetail = false;

		if (lsRaceCard != undefined) {
			var raceDateFromSavedRaceCard = convertStringToDate(lsRaceCard[0].raceDate + " 00:00:00");
			var today = new Date();
			today.setHours(0);
			today.setMinutes(0);
			today.setSeconds(0);

			if (raceDateFromSavedRaceCard >= today) {
				skipDetail = true;
			}
		}
    */
    let reqCmd = Constants.WS_CODE_GET_RACE_DAY_INFO_REQUEST;
    let respCmd = Constants.WS_CODE_GET_RACE_DAY_INFO_RESPONSE;
    var param = {
      "langName": langName,
      "skipDetail": skipDetail
    };
    return this.send(param, reqCmd, respCmd);
  }

  public getHorseRaceCardsAndTips(langName) {
    let reqCmd = Constants.WS_CODE_GET_RACES_REQUEST;
    let respCmd = Constants.WS_CODE_GET_RACES_RESPONSE;
    var param = {
      "langName": langName
    };
    return this.send(param, reqCmd, respCmd);
  }

  //	/tipster/subscribed/list/{subscribe_type}
  //	{"clientEvent":{"getTipsterSubscribedReqInfo":{"subscribeType":"type"},"command":36,"seq":1}}
  public getHorseFollowedAndSubscribed(subscribeType, startIdx, endIdx) {
    let reqCmd = Constants.WS_CODE_GET_TIPSTER_SUBSCRIBED_REQUEST;
    let respCmd = Constants.WS_CODE_GET_TIPSTER_SUBSCRIBED_RESPONSE;
    var param = {
      "subscribeType": subscribeType,
      "startIdx": startIdx,
      "endIdx": endIdx
    };
    return this.send(param, reqCmd, respCmd);
  }

  //	/tipster/subscriber/list/{subscribe_type}
  //	{"clientEvent":{"getTipsterSubscribedReqInfo":{"subscribeType":"type"},"command":38,"seq":1}}
  public getHorseFollowerAndSubscriber(subscribeType, startIdx, endIdx) {
    let reqCmd = Constants.WS_CODE_GET_TIPSTER_SUBSCRIBER_REQUEST;
    let respCmd = Constants.WS_CODE_GET_TIPSTER_SUBSCRIBER_RESPONSE;
    var param = {
      "subscribeType": subscribeType,
      "startIdx": startIdx,
      "endIdx": endIdx
    };
    return this.send(param, reqCmd, respCmd);
  }

  public followAndSubscribe(tipster, type) {
    let reqCmd = Constants.WS_CODE_GET_SUBSCRIBE_TIPSTER_REQUEST;
    let respCmd = Constants.WS_CODE_GET_SUBSCRIBE_TIPSTER_RESPONSE;
    var param = {
      "tipster": tipster,
      "subscribeType": type
    };
    return this.send(param, reqCmd, respCmd);
  }

  public getHorseBlockedList(startIdx, endIdx) {
    let reqCmd = Constants.WS_CODE_GET_TIPSTER_BLOCKED_REQUEST;
    let respCmd = Constants.WS_CODE_GET_TIPSTER_BLOCKED_RESPONSE;
    var param = { "startIdx": startIdx, "endIdx": endIdx };
    return this.send(param, reqCmd, respCmd);
  }

  public blockHorseUser(user, subscribeType) {
    let reqCmd = Constants.WS_CODE_GET_BLOCK_TIPSTER_USER_REQUEST;
    let respCmd = Constants.WS_CODE_GET_BLOCK_TIPSTER_USER_RESPONSE;
    var param = {
      "user": user,
      "subscribeType": subscribeType
    };
    return this.send(param, reqCmd, respCmd);
  }

  public editHorseTip(tipsId, ownerId, dayRaceNo, wpStrategy, wpHorseNo, qqpStrategy, qqpBanker, qqpLegs, confidenceLevel, discussionPosts, note, status, image) {
    let reqCmd = Constants.WS_CODE_EDIT_RACE_TIPS_REQUEST;
    let respCmd = Constants.WS_CODE_EDIT_RACE_TIPS_RESPONSE;
    let img = "";
    if (image != null && image != "") {
      // extract the data part
      img = image.split(",")[1];
    }
    var param = {
      "id": tipsId,
      "ownerId": ownerId,
      "dayRaceNo": dayRaceNo,
      "wpStrategy": wpStrategy,
      "wpHorseNo": wpHorseNo,
      "qqpStrategy": qqpStrategy,
      "qqpBanker": qqpBanker,
      "qqpLegs": qqpLegs,
      "confidenceLevel": confidenceLevel,
      "discussionPosts": discussionPosts,
      "note": note,
      "status": status,
      "image": img
    };
    return this.send(param, reqCmd, respCmd);
  }

  public createHorseTip(raceId, ownerId, dayRaceNo, wpStrategy, wpHorseNo, qqpStrategy, qqpBanker, qqpLegs, confidenceLevel, discussionPosts, note, image) {
    let reqCmd = Constants.WS_CODE_ADD_RACE_TIPS_REQUEST;
    let respCmd = Constants.WS_CODE_ADD_RACE_TIPS_RESPONSE;
    let img = "";
    if (image != null && image != "") {
      // extract the data part
      img = image.split(",")[1];
    }
    var param = {
      "raceId": raceId,
      "ownerId": ownerId,
      "dayRaceNo": dayRaceNo,
      "wpStrategy": wpStrategy,
      "wpHorseNo": wpHorseNo,
      "qqpStrategy": qqpStrategy,
      "qqpBanker": qqpBanker,
      "qqpLegs": qqpLegs,
      "confidenceLevel": confidenceLevel,
      "discussionPosts": discussionPosts,
      "note": note,
      "image": img
    };
    return this.send(param, reqCmd, respCmd);
  }

  public publishHorseTip(id) {
    let reqCmd = Constants.WS_CODE_GET_PUBLISH_TIPS_REQUEST;
    let respCmd = Constants.WS_CODE_GET_PUBLISH_TIPS_RESPONSE;
    var param = {
      "id": id
    };
    return this.send(param, reqCmd, respCmd, false);
  }

  public buyHorseTip(tipsId, raceNum, isTipsPackage) {
    let reqCmd = Constants.WS_CODE_GET_NEW_BUY_TIPS_REQUEST;
    let respCmd = Constants.WS_CODE_GET_NEW_BUY_TIPS_RESPONSE;
    var param = {
      "id": tipsId,
      "dayRaceNo": raceNum, // The parameter 'dayRaceNo' will not be used in server
      "tipsPackage": isTipsPackage
    };
    return this.send(param, reqCmd, respCmd, false);
  }

  public sendSMS(phone, device) {
    let reqCmd = Constants.WS_CODE_GET_ACTIVATION_CODE_REQUEST;
    let respCmd = Constants.WS_CODE_GET_ACTIVATION_CODE_RESPONSE;
    var param = {
      "phone": phone,
      "device": device
    };
    return this.send(param, reqCmd, respCmd);
  }

  public submitSMSCode(phone, code) {
    let reqCmd = Constants.WS_CODE_VERIFY_ACTIVATION_CODE_REQUEST;
    let respCmd = Constants.WS_CODE_VERIFY_ACTIVATION_CODE_RESPONSE;
    var param = {
      "phone": phone,
      "code": code
    };
    return this.send(param, reqCmd, respCmd);
  }

  public regUserReqInfo(mobile, nickName, email, image) {
    let reqCmd = Constants.WS_CODE_REG_USER_REQUEST;
    let respCmd = Constants.WS_CODE_REG_USER_RESPONSE;
    var param = {
      "mobile": mobile,
      "nickName": nickName,
      "email": email,
      "image": image
    };
    return this.send(param, reqCmd, respCmd);
  }

  public getVerfiyStatus() {
    let reqCmd = Constants.WS_CODE_GET_VERIFY_TIPSTER_STATUS_REQUEST;
    let respCmd = Constants.WS_CODE_GET_VERIFY_TIPSTER_STATUS_RESPONSE;
    var param = {};
    return this.send(param, reqCmd, respCmd);
  }

  public addVerify(idImage, addrProofImg) {
    let reqCmd = Constants.WS_CODE_ADD_VERIFY_TIPSTER_REQUEST;
    let respCmd = Constants.WS_CODE_ADD_VERIFY_TIPSTER_RESPONSE;
    var param = {
      "idImage": idImage,
      "addrProofImg": addrProofImg
    };
    return this.send(param, reqCmd, respCmd);
  }

  public getRedeemTokenStatus() {
    let reqCmd = Constants.WS_CODE_GET_REDEEM_TOKEN_STATUS_REQUEST;
    let respCmd = Constants.WS_CODE_GET_REDEEM_TOKEN_STATUS_RESPONSE;
    var param = {};
    return this.send(param, reqCmd, respCmd);
  }

  public redeemToken(redeemAmount) {
    let reqCmd = Constants.WS_CODE_REDEEM_TOKEN_REQUEST;
    let respCmd = Constants.WS_CODE_REDEEM_TOKEN_RESPONSE;
    var param = {
      "redeemAmount": redeemAmount
    };
    return this.send(param, reqCmd, respCmd);
  }

  public addToken(validationCode, password) {
    let reqCmd = Constants.WS_CODE_ADD_TOKEN_BY_TOKEN_CARD_REQUEST;
    let respCmd = Constants.WS_CODE_ADD_TOKEN_BY_TOKEN_CARD_RESPONSE;
    var param = {
      "validationCode": validationCode,
      "password": password
    };
    return this.send(param, reqCmd, respCmd);
  }

  public getHorseTipsters(startIdx, endIdx, tipsterName, rankingOrderType, isShowLoading) {
    let reqCmd = Constants.WS_CODE_USER_LIST_REQUEST;
    let respCmd = Constants.WS_CODE_USER_LIST_RESPONSE;
    var param = { "startIdx": startIdx, "endIdx": endIdx, "nickname": tipsterName, "order": rankingOrderType };
    return this.send(param, reqCmd, respCmd, true, isShowLoading);
  }

  public getHorseTipster(userId) {
    let reqCmd = Constants.WS_CODE_GET_TIPSTER_INFO_REQUEST;
    let respCmd = Constants.WS_CODE_GET_TIPSTER_INFO_RESPONSE;
    var param = { "id": userId };
    return this.send(param, reqCmd, respCmd);
  }

  public getHorseTransactions(lang) {
    let reqCmd = Constants.WS_CODE_GET_TRANSACTIONS_REQUEST;
    let respCmd = Constants.WS_CODE_GET_TRANSACTIONS_RESPONSE;
    var param = { "langName": lang };
    return this.send(param, reqCmd, respCmd);
  }

  public getHorseActivities(lang) {
    let reqCmd = Constants.WS_CODE_GET_ACTIVITY_REQUEST;
    let respCmd = Constants.WS_CODE_GET_ACTIVITY_RESPONSE;
    var param = { "langName": lang };
    return this.send(param, reqCmd, respCmd);
  }

  public updateHorseTipsPrice(tipsPrice, tipsPackagePrice, allowVoucherBuyTip, allowVoucherBuyPackage, allowRefund, allowTipsPackageRefund) {
    let reqCmd = Constants.WS_CODE_UPDATE_TIPSTER_PRICE_REQUEST;
    let respCmd = Constants.WS_CODE_UPDATE_TIPSTER_PRICE_RESPONSE;
    var param = { "price": tipsPrice, "packagePrice": tipsPackagePrice, "allowVoucherBuyTip": allowVoucherBuyTip, "allowVoucherBuyPackage": allowVoucherBuyPackage, "allowRefund": allowRefund, "allowTipsPackageRefund": allowTipsPackageRefund };
    return this.send(param, reqCmd, respCmd);
  }

  public useReferralCode(validationCode) {
    let reqCmd = Constants.WS_CODE_USE_REFERRAL_CODE_REQUEST;
    let respCmd = Constants.WS_CODE_USE_REFERRAL_CODE_RESPONSE;
    var param = { "validationCode": validationCode };
    return this.send(param, reqCmd, respCmd);
  }

  public getVideoInfo() {
    let reqCmd = Constants.WS_CODE_GET_VIDEO_INFO_REQUEST;
    let respCmd = Constants.WS_CODE_GET_VIDEO_INFO_RESPONSE;
    var param = {
    };
    return this.send(param, reqCmd, respCmd);
  }

  public getFBVideoInfo() {
    let reqCmd = Constants.WS_CODE_FB_GET_VIDEO_INFO_REQUEST;
    let respCmd = Constants.WS_CODE_FB_GET_VIDEO_INFO_RESPONSE;
    var param = {
    };
    return this.send(param, reqCmd, respCmd);
  }

  public getVideoAndArticle(langName:string = Constants.LANG_ZH_TW) {
    let reqCmd = Constants.WS_CODE_GET_VIDEO_AND_ARTICLE_REQUEST;
    let respCmd = Constants.WS_CODE_GET_VIDEO_AND_ARTICLE_RESPONSE;
    var param = {"lang": langName};
    return this.send(param, reqCmd, respCmd);
  }

  public getHorseUserProfile() {
    let reqCmd = Constants.WS_CODE_GET_USER_REQUEST;
    let respCmd = Constants.WS_CODE_GET_USER_RESPONSE;
    var param = {};
    return this.send(param, reqCmd, respCmd);
  }

  public updateHorseUserProfile(userId, email, realName, password, imageStr, biographyDetail, nickname, hearType, receivePromotion, mobileNumber) {
    let reqCmd = Constants.WS_CODE_UPDATE_USER_REQUEST;
    let respCmd = Constants.WS_CODE_UPDATE_USER_RESPONSE;
    var param = {};
    if (email != null && email != "" && email != undefined) {
      param['email'] = email;
    }

    if (realName != null && realName != "" && realName != undefined) {
      param['name'] = realName;
    }

    if (password != null && password != "" && password != undefined) {
      param['password'] = password;
    }

    if (imageStr != null && imageStr != "" && imageStr != undefined) {
      param['image'] = imageStr;
    }

    if (biographyDetail != null) {
      param['biographyDetail'] = biographyDetail;
    }

    if (nickname != null) {
      param['nickname'] = nickname;
    }

    if (hearType != null) {
      param['hearType'] = hearType;
    }

    if (mobileNumber != null) {
      param['mobileNumber'] = mobileNumber;
    }

    param['receivePromotion'] = receivePromotion;

    param['id'] = userId;

    return this.send(param, reqCmd, respCmd);
  }

  public getImage(id, type) {
    this.getImageWithCBID(id, type, "");
  }

  public getImageWithCBID(id, type, callbackId) {
    //		var param = {
    //				"id" : id,
    //				"imageType" : type,
    //				"callbackId" : callbackId
    //				};
    //		var reqString = createWSReq(WS_CODE_GET_IMAGE_REQUEST, param);
    //		//console.log("###CALL###"+reqString);
    //		return this.send(param, reqCmd, respCmd);
  }

  public bankIn(tokenValue, bankInDateTime, image, bank) {
    let reqCmd = Constants.WS_CODE_BANK_IN_REQUEST;
    let respCmd = Constants.WS_CODE_BANK_IN_RESPONSE;
    var param = {
      "image": image,
      "tokenValue": tokenValue,
      "bankInDateTime": bankInDateTime,
      "bank": bank
    };
    return this.send(param, reqCmd, respCmd);
  }

  public getBankInStatus() {
    let reqCmd = Constants.WS_CODE_GET_BANK_IN_STATUS_REQUEST;
    let respCmd = Constants.WS_CODE_GET_BANK_IN_STATUS_RESPONSE;
    var param = {};
    return this.send(param, reqCmd, respCmd);
  }

  public regNotification(device, sysVersion, deviceModel, deviceUniqueId, deviceName, firebaseToken) {
    let reqCmd = Constants.WS_CODE_REG_NOTIFICATION_REQUEST;
    let respCmd = Constants.WS_CODE_REG_NOTIFICATION_RESPONSE;
    var trimmedAppVersion = Constants.VERSION.replace(/\./g, "");
    var param = {
      "device": device, "sysVersion": sysVersion, "deviceModel": deviceModel
      , "deviceUniqueId": deviceUniqueId, "deviceName": deviceName, "token": firebaseToken, "appVersion": trimmedAppVersion
    };
    return this.send(param, reqCmd, respCmd, false);
  }

  public updateHorseUserBiography(userBiographyTitle, userBiographyDetail) {
    let reqCmd = Constants.WS_CODE_UPDATE_USER_BIOGRAPHY_REQUEST;
    let respCmd = Constants.WS_CODE_UPDATE_USER_BIOGRAPHY_RESPONSE;
    var param = { "biographyTitle": userBiographyTitle, "biographyDetail": userBiographyDetail };
    return this.send(param, reqCmd, respCmd);
  }

  public requestInAppPurchase(purchaseToken, productId, method) {
    let reqCmd = Constants.WS_CODE_IN_APP_PURHCASE_REQUEST;
    let respCmd = Constants.WS_CODE_IN_APP_PURCHASE_RESPONSE;
    var param = { "token": purchaseToken, "product": productId, "method": method }; // google play:26 apple:27
    return this.send(param, reqCmd, respCmd);
  }

  public requestCreditCardPayment(paidAmount, creditCardNum, expiryMonth, expiryYear, creditCardId, saveCreditCard, tipsId, tipsPackage, football) {
    let reqCmd = Constants.WS_CODE_IN_APP_PURHCASE_REQUEST;
    let respCmd = Constants.WS_CODE_IN_APP_PURCHASE_RESPONSE;
    var param = { "product": paidAmount, "method": "1", "creditCardNum": creditCardNum, "creditCardExpiryMonth": expiryMonth,
        "creditCardExpiryYear": expiryYear, "creditCardId": creditCardId, "saveCreditCard": saveCreditCard,
        "tipsId": tipsId, "tipsPackage": tipsPackage, "football": football };
    return this.send(param, reqCmd, respCmd);
  }

  public deleteCreditCard(creditCardId) {
    let reqCmd = Constants.WS_CODE_DELETE_CREDIT_CARD_REQUEST;
    let respCmd = Constants.WS_CODE_DELETE_CREDIT_CARD_RESPONSE;
    var param = { "creditCardId": creditCardId };
    return this.send(param, reqCmd, respCmd);
  }

  public buyHorseTipsByGoogleInAppPurchase(purchaseToken, productId, tipsId, isTipsPackage) {
    let reqCmd = Constants.WS_CODE_BUY_TIPS_BY_IAP_REQUEST;
    let respCmd = Constants.WS_CODE_BUY_TIPS_BY_IAP_RESPONSE;
    let param = { "token": purchaseToken, "product": productId, "method": "26", "tipsId": tipsId, "tipsPackage": isTipsPackage };
    return this.send(param, reqCmd, respCmd);
  }

  public checkHorseTipsPurchased(tipsId, isTipsPackage) {
    let param = { "id": tipsId, "tipsPackage": isTipsPackage };
    let reqCmd = Constants.WS_CODE_CHECK_TIPS_PURCHASED_REQUEST;
    let respCmd = Constants.WS_CODE_CHECK_TIPS_PURCHASED_RESPONSE;
    return this.send(param, reqCmd, respCmd);
  }

  public blockRaceComment(raceId, commentId, shouldCensored, shouldTempCensored) {
    let reqCmd = Constants.WS_CODE_BLOCK_RACE_COMMENT_REQUEST;
    let respCmd = Constants.WS_CODE_BLOCK_RACE_COMMENT_RESPONSE;
    let param = { "raceId": raceId, "id": commentId, "censored": shouldCensored, "tempCensored": shouldTempCensored };
    return this.send(param, reqCmd, respCmd);
  }

  public setNotification(isNotifyHorseRaceInfo, isNotifyHorseBuyTipInfo, isNotifyFollowedHorseTipPublished,
    isNotifyHorseWriteTipInfo, isNotifyFbMatchInfo, isNotifyFbBuyTipInfo, isNotifyFollowedFbTipPublished, isNotifyFbWriteTipInfo,
    isNotifyCommentAdded, isNotifyVideoReady) {
    let reqCmd = Constants.WS_CODE_UPDATE_NOTIFICATION_PREFERENCE_REQUEST;
    let respCmd = Constants.WS_CODE_UPDATE_NOTIFICATION_PREFERENCE_RESPONSE;
    var param = {
      "notifyRaceInfo": isNotifyHorseRaceInfo, "notifyBuyTipInfo": isNotifyHorseBuyTipInfo,
      "notifyTipPublished": isNotifyFollowedHorseTipPublished, "notifyWriteTipInfo": isNotifyHorseWriteTipInfo,
      "notifyFbMatchInfo": isNotifyFbMatchInfo, "notifyFbBuyTipInfo": isNotifyFbBuyTipInfo,
      "notifyFbTipPublished": isNotifyFollowedFbTipPublished, "notifyFbWriteTipInfo": isNotifyFbWriteTipInfo,
      "notifyCommentAdded": isNotifyCommentAdded, "notifyVideoReady": isNotifyVideoReady
    };
    return this.send(param, reqCmd, respCmd);
  }

  public editHorsePackageTip(tipsPackageId, raceDate, raceTips, tipsPackageNotes, status, modifiedInfoJSON, tipsPackageImgSrc) {
    let reqCmd = Constants.WS_CODE_EDIT_PACKAGE_TIPS_REQUEST;
    let respCmd = Constants.WS_CODE_EDIT_PACKAGE_TIPS_RESPONSE;
    let img = "";
    if (tipsPackageImgSrc != null && tipsPackageImgSrc != "") {
      // extract the data part
      img = tipsPackageImgSrc.split(",")[1];
    }
    var param = {
      "id": tipsPackageId,
      "raceDate": raceDate,
      "raceTips": raceTips,
      "note": tipsPackageNotes,
      "status": status,
      "modifiedInfoJSON": modifiedInfoJSON,
      "image": img
    };
    return this.send(param, reqCmd, respCmd);
  }

  public createHorsePackageTip(raceDate, raceTips, tipsPackageNotes, status, tipsPackageImgSrc) {
    let reqCmd = Constants.WS_CODE_CREATE_PACKAGE_TIPS_REQUEST;
    let respCmd = Constants.WS_CODE_CREATE_PACKAGE_TIPS_RESPONSE;
    let img = "";
    if (tipsPackageImgSrc != null && tipsPackageImgSrc != "") {
      // extract the data part
      img = tipsPackageImgSrc.split(",")[1];
    }
    var param = {
      "raceDate": raceDate,
      "raceTips": raceTips,
      "note": tipsPackageNotes,
      "status": status,
      "image": img
    };
    return this.send(param, reqCmd, respCmd);
  }

  public getHorsePackageTip(id, lang) {
    let reqCmd = Constants.WS_CODE_GET_PACKAGE_TIPS_REQUEST;
    let respCmd = Constants.WS_CODE_GET_PACKAGE_TIPS_RESPONSE;
    var param = {
      "id": id,
      "lang": lang
    };
    return this.send(param, reqCmd, respCmd);
  }

  public publishHorsePackageTip(id) {
    let reqCmd = Constants.WS_CODE_PUBLISH_PACKAGE_TIPS_REQUEST;
    let respCmd = Constants.WS_CODE_PUBLISH_PACKAGE_TIPS_RESPONSE;
    var param = {
      "id": id
    };
    return this.send(param, reqCmd, respCmd);
  }

  public getHorseTipsPackageLatestResult(id) {
    let reqCmd = Constants.WS_CODE_GET_LATEST_PACKAGE_TIPS_REQUEST;
    let respCmd = Constants.WS_CODE_GET_LATEST_PACKAGE_TIPS_RESPONSE;
    var param = {
      "id": id
    };
    return this.send(param, reqCmd, respCmd);
  }

  public getCreditCardInfo(lang) {
    let reqCmd = Constants.WS_CODE_GET_CREDIT_CARD_INFO_REQUEST;
    let respCmd = Constants.WS_CODE_GET_CREDIT_CARD_INFO_RESPONSE;
    var param = { "langName": lang };
    return this.send(param, reqCmd, respCmd);
  }

  public notifyBuyersTipsPackageUpdated(tipsPackageId) {
    let param = { "id": tipsPackageId, "langName": Constants.LANG_ZH_TW };
    let reqCmd = Constants.WS_CODE_NOTIFY_BUYERS_TIPS_PACKAGE_UPDATED_REQUEST;
    let respCmd = Constants.WS_CODE_NOTIFY_BUYERS_TIPS_PACKAGE_UPDATED_RESPONSE;
    return this.send(param, reqCmd, respCmd).catch(err => console.log);
  }

  public notifyBuyersFbTipsPackageUpdated(fbTipsPackageId) {
    let param = { "id": fbTipsPackageId, "lang": Constants.LANG_ZH_TW };
    let reqCmd = Constants.WS_CODE_NOTIFY_BUYERS_FB_TIPS_PACKAGE_UPDATED_REQUEST;
    let respCmd = Constants.WS_CODE_NOTIFY_BUYERS_FB_TIPS_PACKAGE_UPDATED_RESPONSE;
    return this.send(param, reqCmd, respCmd).catch(err => console.log);
  }

  public getRaceHorseNotes(raceId, lang) {
    let reqCmd = Constants.WS_CODE_GET_RACE_HORSE_NOTES_REQUEST;
    let respCmd = Constants.WS_CODE_GET_RACE_HORSE_NOTES_RESPONSE;
    var param = { "raceId": raceId, "lang": lang };
    return this.send(param, reqCmd, respCmd);
  }

  public sendPing() {
    let param = { "langName": Constants.LANG_ZH_TW };
    let reqCmd = Constants.WS_CODE_PING_REQUEST;
    let respCmd = Constants.WS_CODE_PING_RESPONSE;
    return this.send(param, reqCmd, respCmd).catch(err => console.log);
  }

  public logLiveStreaming() {
    let reqCmd = Constants.WS_CODE_LOG_LIVE_STREAMING_REQUEST;
    let respCmd = Constants.WS_CODE_LOG_LIVE_STREAMING_RESPONSE;
    var param = {};
    return this.send(param, reqCmd, respCmd);
  }

  public claimReward(tipId, isFb, returnInfo: number) {
    let param = {"id": tipId, "returnInfo": returnInfo};
    if (isFb) {
      param['note'] = "1"; // Football
    } else {
      param['note'] = "0"; // Horse
    }
    let reqCmd = Constants.WS_CODE_CLAIM_REWARD_REQUEST;
    let respCmd = Constants.WS_CODE_CLAIM_REWARD_RESPONSE;
    return this.send(param, reqCmd, respCmd, false);
  }

  public showAlertMsg(response) {
    return new Promise<any>((resolve, reject) => {
      let responseCode = response.code;
      if (responseCode == null) {
        responseCode = "ce100003";
      }
      this.translateService.get(responseCode).subscribe((res: string) => {
        let sTitle = this.translateService.instant("error");
        if (responseCode == "100023") {
          sTitle = this.translateService.instant("kindReminder");
        }
        let alert = this.alertCtrl.create({
          title: sTitle,
          subTitle: res,
          buttons: ["OK"]
        });
        this.showingPopUp = true;
        alert.present();
        alert.onDidDismiss(() => this.showingPopUp = false);
        resolve(response);
      });
    });
  }

  private send(param: Object, reqCmd: number, respCmd: number, promptError = true, isShowLoading: boolean = true) {
    return new Promise<any>((resolve, reject) => {
      let thisReqId = this.reqId++;
      let msg = this.createWSReq(reqCmd, param, thisReqId);
      if (isShowLoading) {
        this.loadingCtrl.createCmdLoading(reqCmd);
      }
      this.sendData(msg, thisReqId, respCmd).then(
        response => {
          if (isShowLoading) {
            this.loadingCtrl.dismissCmdLoading(reqCmd);
          }
          if (response == null) {
            reject("response is null");
            return;
          }

          if (response.result) {
            resolve(response);
          } else {
            console.log("[send] response result is False");
            console.log(response);
            if (promptError && !this.showingPopUp) {
              this.showAlertMsg(response).then(response =>{
                reject(response);
              });
            } else {
              reject(response);
            }

          }
        },
        err => {
          if (isShowLoading) {
            this.loadingCtrl.dismissCmdLoading(reqCmd);
          }
          console.log("[send] Received error. Req Cmd:" + reqCmd);

          if (err instanceof Event) {
            console.log("Received event as error");
            console.log(err);
            reject(err);
            return;
          }

          console.log(err);

          let errorMsg = err.message;

          if (err.message == Constants.CLIENT_ERROR_CODE_ACCESS_DENIED
            || err.message == Constants.CLIENT_ERROR_CODE_WEB_SOCKET_URL_INVALID) {
            console.log("[send] Received Access Denied. Will show pop up: " + !this.showingPopUp);
            if (!this.showingPopUp) {
              let forceLogoutAlert = this.alertCtrl.create({
                title: this.translateService.instant("error"),
                subTitle: this.translateService.instant(err.message),
                buttons: [{
                  text: this.translateService.instant("ok"),
                  handler: () => {
                    let isUpdating = this.app.getActiveNavs() != null && this.app.getActiveNavs().length > 0 && this.app.getActiveNavs()[0].getActive().name == "UpdateAppPage";
                    if (!isUpdating) {
                      this.loadingCtrl.createCmdLoading(Constants.LOADING_ACCESS_DENIED);
                      this.userManager.logout();
                      this.destroy();
                      if (this.app.getActiveNavs().length > 0) {
                        this.app.getActiveNavs()[0].setRoot("StartUpPage", {}, { animate: true, direction: 'backward' });
                      } else {
                        this.showLogin();
                      }
                    }
                  }
                }]
              });
              this.showingPopUp = true;
              forceLogoutAlert.present();
              forceLogoutAlert.onDidDismiss(() => {
                this.showingPopUp = false;
                this.loadingCtrl.dismissCmdLoading(Constants.LOADING_ACCESS_DENIED);
              });
            }
            reject(errorMsg);
            return;
            // errorMsg = this.translateService.instant(Constants.CLIENT_ERROR_CODE_ACCESS_DENIED);
          }


          if (err.message == Constants.CLIENT_ERROR_CODE_WEB_SOCKET_NOT_READY) {
            // let the keep alive subscription handle the connection issue
            //errorMsg = this.translateService.instant(Constants.CLIENT_ERROR_CODE_WEB_SOCKET_NOT_READY);
            //reject(errorMsg);
            this.connectWS();
            /*
            this.connectionStatusSubject.asObservable().distinctUntilChanged().filter(isConnected => isConnected == true).take(1).subscribe(connected => {
              resolve(this.send(param, reqCmd, respCmd));
            });
            */
            //resolve(this.send(param, reqCmd, respCmd));
            return;
          }


          if (err.name == "TimeoutError") {
            errorMsg = this.translateService.instant(Constants.CLIENT_ERROR_CODE_TIMEOUT);
          }

          if (errorMsg == "") {
            errorMsg = JSON.stringify(err);
          }

          if (promptError && !this.showingPopUp) {
            this.translateService.get("error").subscribe((res: string) => {
              let alert = this.alertCtrl.create({
                title: res,
                subTitle: this.translateService.instant(errorMsg),
                buttons: ["OK"]
              });
              this.showingPopUp = true;
              alert.present();
              alert.onDidDismiss(() => this.showingPopUp = false);
              reject(errorMsg);
            });
          } else {
            reject(errorMsg);
          }
        }
      );
    });

  }


  private createWSReq(command: number, value: Object, reqId: number) {
    let reqRoot = {};

    let reqAttr = {};
    reqAttr['command'] = command;
    reqAttr['seq'] = 1;
    reqAttr['reqId'] = reqId;

    if (value != undefined) {
      let key = Constants.WS_CODES_KEY_MAP[command];
      reqAttr[key] = value;
    }

    reqRoot['clientEvent'] = reqAttr;

    return JSON.stringify(reqRoot);
  }

  private sendData(jsonMsg: string, reqId: number, respCmd: number) {
    if (!this.subject) {
      console.log("[sendData] Web socket not ready");
      //throw new Error(Constants.CLIENT_ERROR_CODE_WEB_SOCKET_NOT_READY);
      //this.connectWS();
      //this.showLogin();
      //return null;
      return Promise.reject(new Error(Constants.CLIENT_ERROR_CODE_WEB_SOCKET_NOT_READY));
    }
    this.subject.next(jsonMsg);
    var observable = this.subject;
    return observable
      .filter(
      res => {
        return res.clientEvent.command == Constants.WS_CODE_ACCESS_DENIED || (res.clientEvent.command == respCmd && res.clientEvent.reqId == reqId);
      }
      )
      .map(
      res => {
        if (res['clientEvent'] == undefined) {
          console.log("[sendData] Received Invalid response");
          throw new Error(Constants.CLIENT_ERROR_CODE_INVALID_RESPONSE);
        }

        if (res.clientEvent.Error != undefined) {
          console.log("[sendData] Received error");
          throw new Error(JSON.stringify(res));
        }

        if (res.clientEvent.command == Constants.WS_CODE_ACCESS_DENIED) {
          console.log("[sendData] Received Access Denied");
          throw new Error(Constants.CLIENT_ERROR_CODE_ACCESS_DENIED);
        }

        if (res.clientEvent[Constants.WS_CODES_KEY_MAP[respCmd]] == undefined) {
          console.log("[sendData] Invalid mapping between request and response");
          throw new Error(Constants.CLIENT_ERROR_CODE_INVALID_MAPPING);
        }

        return res.clientEvent[Constants.WS_CODES_KEY_MAP[respCmd]];
      }
      )
      .take(1)
      // .timeout(10000)
      .toPromise();
  }

  public getFbMatchBetsObj(matchId: number, matchDetailsHeader: MatchDetailsHeaderObject, refresher?) {
    return new Promise<any>((resolve: any, reject) => {
      this.getFbMatchBets(matchId).then(
        result => {
          console.log("Promise ok getFbMatchBetsObj");
          console.log(JSON.stringify(result));
          let aFbBetRow: Array<FbBetRow> = [];
          for (let fbBetRow of result.bet) {
            let aFbBet: Array<FbBet> = [];
            for (let fbBet of fbBetRow.bet) {
              aFbBet.push(new FbBet(fbBet.betType, fbBet.itemOption, fbBet.winningMargin, fbBet.odds, fbBet.selected));
            }
            let oFbBetRow: FbBetRow = new FbBetRow(aFbBet, fbBetRow.tipPublished, fbBetRow.betAmount,
              fbBetRow.createDate, fbBetRow.price);
            aFbBetRow.push(oFbBetRow);
          }
          matchDetailsHeader.copy(new MatchDetailsHeaderObject(result.id, result.matchNum, result.dayOfWeek, result.startTime,
            result.currentMin, result.matchProgress, result.homeName, result.awayName, result.homeScore, result.awayScore,
            result.cornerNum, result.firstHalfHomeScore, result.firstHalfAwayScore, result.tipsPublishClosed, aFbBetRow, result.matchDay,
            result.date));

          if (refresher != null) {
            refresher.complete();
          }
          resolve();
        },
        err => {
          console.log(err);
          if (refresher != null) {
            refresher.complete();
          }
          reject();
        }
      );
    });
  }

  public getFbPersonalTipsList(matchId, availableFbPersonalTips,
    purchasedFbPersonalTips, voucherBalance, matchDay, refresher?) {
    return new Promise((resolve: any, reject) => {
      this.getFbPersonalTips(matchId, matchDay).then(result => {
        result.FbPersonalTip.forEach(element => {
          let tipsterInfoJson = element.tipsterInfo;
          let tipsterInfo = Util.convertTipsterInfoFromJson(tipsterInfoJson);
          let fbPersonalTips: FbPersonalTips = null;
          let tipPurchased;
          element.fbTipList.forEach(fbTip => {
            let tipId = fbTip.id;
            tipPurchased = fbTip.purchased;
            let tipPrice = Util.getActualNumber(fbTip.price);
            let tipBetAmount = Util.getActualNumber(fbTip.betAmount);
            let tipDividend = Util.getActualNumberWithMinusOne(fbTip.dividend);
            let tipBetAmountQuota = Util.getActualNumber(fbTip.betAmountQuota);

            let associateType = element.associateType;

            // let fbBet = fbTip.fbBet;
            let voucherCost = fbTip.voucherCost;
            let canUseVoucher = fbTip.voucherCost > 0;
            let allowVoucher = fbTip.allowVoucher;
            let note = fbTip.note;
            let image = fbTip.image;
            let availableForPurchase = fbTip.availableForPurchase;
            let packageId = fbTip.packageId;
            let purchaseDate = fbTip.purchaseDate;
            let createDate = fbTip.createDate;
            let packageBetAmount = Util.getActualNumber(fbTip.packageBetAmount);
            let packageCurrentBetAmount = Util.getActualNumber(fbTip.packageCurrentBetAmount);
            let packageDividend = Util.getActualNumberWithMinusOne(fbTip.packageDividend);

            let allowRefund = fbTip.allowRefund;

            // //let betType = Constants.Enum_BetType[fbBet.betType];
            // let betType = fbBet.betType;
            // //let betItemOption = Constants.Enum_BetItemOption[fbBet.itemOption];
            // let betItemOption = fbBet.itemOption;
            // let odds = Util.getActualNumber(fbBet.odds).toString();
            // let winningMargin = fbBet.winningMargin;
            // let winningMarginChanged = fbBet.winningMarginChanged;

            // let fbBetModel = new FbBetModel(betType, tipBetAmount, tipBetAmountQuota, betItemOption,
            //   winningMargin, winningMarginChanged, odds, tipDividend);
            let fbBet = fbTip.fbBet;
            let isRefund = fbTip.isRefund;
            let betType = fbBet.betType;
            let betItemOption = fbBet.itemOption;
            let odds = Util.getActualNumber(fbBet.odds).toString();
            let winningMargin = fbBet.winningMargin;
            let winningMarginChanged = fbBet.winningMarginChanged;
            // let tipsId = fbBet.tipsId;
            let fbBetModel = new FbBetModel(betType, tipBetAmount, tipBetAmountQuota, betItemOption,
              winningMargin, winningMarginChanged, odds, tipDividend, tipId, createDate, note, image, isRefund);
            if (fbPersonalTips == null) {
              let fbBetList: Array<FbBetModel> = new Array<FbBetModel>();
              fbBetList.push(fbBetModel);
              let fbTipPrice = new FbTipPrice(tipPurchased, tipPrice, voucherCost, canUseVoucher, allowVoucher, voucherBalance);
              fbPersonalTips = new FbPersonalTips(tipId, tipsterInfo, associateType, note, image, fbBetList, fbTipPrice,
                availableForPurchase, packageId, purchaseDate, packageBetAmount, packageCurrentBetAmount, packageDividend, allowRefund);
            } else {
              fbPersonalTips.fbBetList.push(fbBetModel);
            }
          });

          // let betAmount = 0;
          // let dividend = -1;
          // let currentBetAmount = 0;
          // fbPersonalTips.fbBetList.forEach(fbBetModel => {
          //   betAmount += fbBetModel.betAmount;
          //   if (fbBetModel.dividend != -1) {
          //     if (dividend == -1) {
          //       dividend = fbBetModel.dividend;
          //     } else {
          //       dividend += fbBetModel.dividend;
          //     }
          //     currentBetAmount += fbBetModel.betAmount;
          //   }
          // });
          // fbPersonalTips.betAmount = betAmount;
          // fbPersonalTips.dividend = dividend;
          // fbPersonalTips.currentBetAmount = currentBetAmount;
          if (tipPurchased) {
            purchasedFbPersonalTips.push(fbPersonalTips);
          } else {
            availableFbPersonalTips.push(fbPersonalTips);
          }
        });
        if (refresher != null) {
          refresher.complete();
        }
        resolve();
      },
        err => {
          if (refresher != null) {
            refresher.complete();
          }
          console.log("Error");
          console.log(err);
          reject();
        });
    });
  }

  public getTipsterInfoObj<T extends UserProfile>(userProfile: T, userId?: number): Promise<any> {
    return new Promise<any>((resolve: any, reject) => {
      if (userId == null || userId == undefined) {
        userId = this.customStorageService.get<number>(Constants.STORAGE_KEY_USER_ID);
      }
      this.getTipsterInfo(userId).then(tipsterInfo => {
        userProfile.copy(new FbTipsterInfo(tipsterInfo.id, tipsterInfo.nickname, tipsterInfo.ranking,
          Util.getActualNumber(tipsterInfo.tipScore), tipsterInfo.profitability, Util.getActualNumber(tipsterInfo.accuracy),
          tipsterInfo.win, tipsterInfo.lose, tipsterInfo.subscribeType,
          tipsterInfo.accuracyRanking, tipsterInfo.profitabilityRanking, tipsterInfo.last7DaysAccuracyRanking,
          tipsterInfo.last7DaysProfitabilityRanking, Util.getActualNumber(tipsterInfo.profit),
          Util.getActualNumber(tipsterInfo.last7DaysProfit), tipsterInfo.profitRanking,
          tipsterInfo.last7DaysProfitRanking, tipsterInfo.last7DaysProfitability,
          tipsterInfo.last7DaysAccuracy, tipsterInfo.subscribeType, tipsterInfo.buyerCount,
          Util.getActualNumber(tipsterInfo.betAmount), Util.getActualNumber(tipsterInfo.tipsPackagePrice), tipsterInfo.biographyDetail,
          Util.getActualNumber(tipsterInfo.highestScore), tipsterInfo.allowVoucherBuyPackage, tipsterInfo.allowTipsPackageRefund));
        resolve();
      },
        err => {
          console.log(err);
          reject(err);
        });
    });
  }

  isGuest(): boolean {
    return this.userManager.isGuest();
  }

  public toggleFollowTipster(tipsterInfo: UserProfile) {
    // if (this.isGuest()) {
    //   let alert = this.alertCtrl.create({
    //     title: this.translateService.instant("error"),
    //     subTitle: this.translateService.instant("alertMessageNotAllowGuestFollow"),
    //     buttons: [
    //       {
    //         text: this.translateService.instant("ok"),
    //         handler: () => {
    //         }
    //       }
    //     ]
    //   });
    //   alert.present();
    // } else {
      if (tipsterInfo.subscribeType == 0) {
        this.subscribeFbTipster(tipsterInfo.id, 1).then(response => {
          tipsterInfo.subscribeType = 1;
        },
          err => {
            console.log("Failed to follow");
            console.log(err);
          });
      } else {
        this.subscribeFbTipster(tipsterInfo.id, 0).then(response => {
          tipsterInfo.subscribeType = 0;
        },
          err => {
            console.log("Failed to unfollow");
            console.log(err);
          })
      }
    // }
  }

  public buyTips4Guest(tipPrice: number, tipsId: number, tipsPackage: boolean, football: boolean, fbTipsPackageDetails, content, modalCtrl, navCtrl, fbTipPrice: FbTipPrice, selectedMatchId,
    horseDataConverterProvider?, personalTips?, tips?) {
    if (!this.userManager.isGuest())  {
      let sTitle = this.translateService.instant("100015");
      let sSubTitle = this.translateService.instant("buyTipsNotEnoughCoin");

      let alert = this.alertCtrl.create({
        title: sTitle,
        subTitle: sSubTitle,
        buttons: [
          {
            text: this.translateService.instant("cancel"),
            role: "cancel"
          },
          {
            text: this.translateService.instant("ok"),
            handler: ()=> {
                if (this.app.getActiveNavs() != null && this.app.getActiveNavs().length > 0) {
                  let navCtrl = this.app.getActiveNavs()[0];
                  navCtrl.push("ShopMenuPage").then(result => {
                    if (!result) {
                      navCtrl.push("InAppPurchasePage");
                    }
                  })
                }
            }
          }
        ]
      });

      alert.present();
      alert.onDidDismiss(() => {
      });
      return;
    }
    let modal = modalCtrl.create(Constants.CREDIT_CARD_TYPE_PAGE, { tipPrice: tipPrice,
        tipsId: tipsId, tipsPackage: tipsPackage, football: football }, { enableBackdropDismiss: false });
    modal.onDidDismiss(data => {
      console.log("onDidDismiss");
      console.log(data);
      if (data != null && data.result != null && data.creditCardType != null) {
        if (data.result) {
          if (data.creditCardType == CreditCard.VisaMaster || data.creditCardType == CreditCard.UnionPay) {
            if (football) {
              this.pushFbTipsPackageDetails(navCtrl, tipsId, fbTipPrice, selectedMatchId, fbTipsPackageDetails, content);
            } else {
              if (tipsPackage) {
                this.pushHorsePackageDetails(navCtrl, tipsId, personalTips, tips)
              } else {
                if (personalTips != null) {
                  console.log("personalTipspersonalTips");
                  // for the page horse-home-list-tips
                  this.getHorseRaceTips(tipsId, this.customStorageService.get<string>(Constants.STORAGE_KEY_LANG), false).then(response => {
                    let rawRaceTip = response.RaceTip[0];
                    let rawRaceCard = response;
                    let raceCard = horseDataConverterProvider.convertRawDataToSingleRaceCard(rawRaceCard);
                    let horses = raceCard.horses;
                    let purchasedInRaceTips = horseDataConverterProvider.getInRaceTipsModel(horses, rawRaceTip, personalTips.tips.tipster);
                    personalTips.tips = purchasedInRaceTips;
                  }, err => {
                    console.log(err);
                  });
                } else if (tips != null) {
                  console.log("tipstips");
                  // for the page horse-tipster-info
                  tips.purchased = true;
                  navCtrl.push("HorseInRaceTipsDetailsPage", { tipsId: tipsId });
                }
              }
            }
          }
        } else if (!data.result) {
          if (data.creditCardType == CreditCard.VisaMaster || data.creditCardType == CreditCard.UnionPay) {
            if (football) {
              this.getFbTipsPackageDetails(tipsId, this.customStorageService.get<string>(Constants.STORAGE_KEY_LANG)).then(response => {
                console.log(response);
                if (response.result && response.purchased) {
                  this.pushFbTipsPackageDetails(navCtrl, tipsId, fbTipPrice, selectedMatchId, fbTipsPackageDetails, content);
                }
              }, err => {
                console.log(err);
              });
            } else {
              if (tipsPackage) {
                this.getHorsePackageTip(tipsId, this.customStorageService.get<string>(Constants.STORAGE_KEY_LANG)).then(response => {
                  console.log(response);
                  if (response != null && response.result && response.tipsPackage != null && response.tipsPackage.purchased != null
                      && response.tipsPackage.purchased && response.tipsPackage.id != null && response.tipsPackage.id == tipsId) {
                    this.pushHorsePackageDetails(navCtrl, tipsId, personalTips, tips)
                  }
                }, err => {
                  console.log(err);
                });
              } else {
                this.getHorseRaceTips(tipsId, this.customStorageService.get<string>(Constants.STORAGE_KEY_LANG), false).then(response => {
                  console.log(response);
                  if (response != null && response.result && response.RaceTip[0] != null && response.RaceTip[0].purchased != null
                        && response.RaceTip[0].purchased && response.RaceTip[0].id != null && response.RaceTip[0].id == tipsId) {
                    if (personalTips != null) {
                      // for the page horse-home-list-tips
                      let rawRaceTip = response.RaceTip[0];
                      let rawRaceCard = response;
                      let raceCard = horseDataConverterProvider.convertRawDataToSingleRaceCard(rawRaceCard);
                      let horses = raceCard.horses;
                      let purchasedInRaceTips = horseDataConverterProvider.getInRaceTipsModel(horses, rawRaceTip, personalTips.tips.tipster);
                      personalTips.tips = purchasedInRaceTips;
                    } else if (tips != null) {
                      // for the page horse-tipster-info
                      tips.purchased = true;
                      navCtrl.push("HorseInRaceTipsDetailsPage", { tipsId: tipsId });
                    }
                  }
                }, err => {
                  console.log(err);
                });
              }
            }

          }
        }
      }
    });
    modal.present();
  }

  private pushFbTipsPackageDetails(navCtrl, tipsId, fbTipPrice, selectedMatchId, fbTipsPackageDetails, content) {
    if (fbTipsPackageDetails != null) {
      // for the page show-tips-package-details
      this.buyFbTipsPackageReq(tipsId).then(
        result => {
          Util.getPersonalTipsPackageFromJson(result, fbTipsPackageDetails, this.userManager);
          content.resize();
        },
        errorResp => {
        });
    } else if (fbTipPrice == null && selectedMatchId == null) {
      // for the page tipster-info
      navCtrl.push("ShowTipsPackageDetailsPage", { tipsPackageId: tipsId });
    } else if (selectedMatchId != null) {
      // for the page fb-tips-list
      navCtrl.push("ShowTipsPackageDetailsPage", { tipsPackageId: tipsId, selectedMatchId: selectedMatchId });
    } else if (fbTipPrice != null) {
      // for the page show-fb-tips-package
      fbTipPrice.purchased = true;
      navCtrl.push("ShowTipsPackageDetailsPage", { tipsPackageId: tipsId, isOnFocusDiscussionTab: true });
    }
  }

  private pushHorsePackageDetails(navCtrl, tipsId, personalTips, tips) {
    if (personalTips != null) {
      // for the page horse-home-list-tips
      personalTips.tips.purchased = true;
    } else if (tips != null) {
      // for the page horse-tipster-info
      tips.purchased = true;
      navCtrl.push("HorseTipsPackageDetailsPage", { tipsId: tipsId });
    }
  }

  public buyTip(fbPersonalTipsComponent: FbPersonalTipsComponent, availableFbPersonalTips: Array<FbPersonalTips>, purchasedFbPersonalTips: Array<FbPersonalTips>,
    tipsterInfoMatchRecordRowComponent: TipsterInfoMatchRecordRowComponent, tipsterInfoMatchRecords: Array<TipsterInfoMatchRecord>) {
    // let confirm = this.alertCtrl.create({
    //   title: this.translateService.instant("confirmBuyTipsTitle"),
    //   message: this.translateService.instant("confirmBuyTipsContent"),
    //   buttons: [
    //     {
    //       text: this.translateService.instant("cancel"),
    //       role: 'cancel',
    //       handler: () => {
    //         console.log('Cancel clicked');
    //       }
    //     },
    //     {
    //       text: this.translateService.instant("ok"),
    //       handler: () => {
    //         let iFbTipId = -1;
    //         if (fbPersonalTipsComponent != null) {
    //           iFbTipId = fbPersonalTipsComponent.fbPersonalTip.tipId;
    //         } else if (tipsterInfoMatchRecordRowComponent != null) {
    //           iFbTipId = tipsterInfoMatchRecordRowComponent.tipsterInfoMatchRecord.tipId;
    //         }
    //         this.buyFbTip(iFbTipId).then(fbTip => {
    //           if (fbPersonalTipsComponent != null) {
    //             fbPersonalTipsComponent.fbPersonalTip.fbBet.betAmount = Util.getActualNumber(fbTip.betAmount);
    //             fbPersonalTipsComponent.fbPersonalTip.fbBet.odds = Util.getActualNumber(fbTip.fbBet.odds).toString();
    //             //fbPersonalTipsComponent.fbPersonalTip.betItemOption = Constants.Enum_BetItemOption[fbTip.fbBet.itemOption];
    //             fbPersonalTipsComponent.fbPersonalTip.fbBet.betItemOption = fbTip.fbBet.itemOption;
    //             fbPersonalTipsComponent.fbPersonalTip.fbTipPrice.purchased = true;
    //             fbPersonalTipsComponent.fbPersonalTip.fbBet.winningMargin = fbTip.fbBet.winningMargin;
    //           } else if (tipsterInfoMatchRecordRowComponent != null) {
    //             tipsterInfoMatchRecordRowComponent.tipsterInfoMatchRecord.betAmount = Util.getActualNumber(fbTip.betAmount);
    //             tipsterInfoMatchRecordRowComponent.tipsterInfoMatchRecord.odds = Util.getActualNumber(fbTip.fbBet.odds);
    //             tipsterInfoMatchRecordRowComponent.tipsterInfoMatchRecord.betItemOption = fbTip.fbBet.itemOption;
    //             tipsterInfoMatchRecordRowComponent.tipsterInfoMatchRecord.fbTipPrice.purchased = true;
    //             tipsterInfoMatchRecordRowComponent.tipsterInfoMatchRecord.winningMargin = fbTip.fbBet.winningMargin;
    //           }
    //           let langName = this.customStorageService.get<string>(Constants.STORAGE_KEY_LANG);
    //           this.getFbTransactions(langName).then(transactions => {
    //             if (fbPersonalTipsComponent != null) {
    //                 availableFbPersonalTips.forEach(element => {
    //                 element.fbTipPrice.voucherBalance = transactions.voucherBalance;
    //               });
    //             } else if (tipsterInfoMatchRecordRowComponent != null) {
    //               tipsterInfoMatchRecords.forEach(element => {
    //                 element.fbTipPrice.voucherBalance = transactions.voucherBalance;
    //               });
    //             }
    //           },
    //             err => {
    //               console.log("[TransactionPage] Error: " + err.message);
    //             });
    //         },
    //           err => {
    //             console.log(err);
    //           });
    //       }
    //     }
    //   ]
    // });
    // confirm.present();
  }

  public getTipsterArticle(langName:string = Constants.LANG_ZH_TW) {
    let reqCmd = Constants.WS_CODE_GET_TIPSTER_ARTICLE_REQUEST;
    let respCmd = Constants.WS_CODE_GET_TIPSTER_ARTICLE_RESPONSE;
    var param = {"lang": langName
    };
    return this.send(param, reqCmd, respCmd);
  }


  public getArticleDetails(tipsterId: number, raceId: number, langName:string = Constants.LANG_ZH_TW) {
    let reqCmd = Constants.WS_CODE_GET_ARTICLE_DETAILS_REQUEST;
    let respCmd = Constants.WS_CODE_GET_ARTICLE_DETAILS_RESPONSE;
    var param = {"lang": langName, userId: tipsterId, raceId: raceId};
    return this.send(param, reqCmd, respCmd);
  }

  public getSpeedArticle(langName:string = Constants.LANG_ZH_TW) {
    let reqCmd = Constants.WS_CODE_GET_SPEED_ARTICLE_REQUEST;
    let respCmd = Constants.WS_CODE_GET_SPEED_ARTICLE_RESPONSE;
    var param = {"lang": langName};
    return this.send(param, reqCmd, respCmd);
  }

  public deactivateAccount(userProfile){
    let reqCmd = Constants.WS_CODE_DISABLE_ACCOUNT_REQUEST;
    let respCmd = Constants.WS_CODE_DISABLE_ACCOUNT_RESPONSE;
    var param = { "UserProfile": userProfile };
    return this.send(param, reqCmd, respCmd);
  }

} // end class WebSocketService




// WEBPACK FOOTER //
// ./src/services/webSocketService.ts